import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import MeetingCard from "../components/widgets/MeetingCard";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";
import MeetingAttendanceModal from "../components/widgets/MeetingAttendanceModal";


const MeetingsPage: React.FC<RouteComponentProps> = ({ history }) => {
  const rootStore = useContext(RootStoreContext);
  const {
    orderedUserMeetings,
    meetingYears,
    meetingAttendanceModal,
    attendingMeeting,
  } = rootStore.playerStore;
  const { currentTenant } = rootStore.tenantStore;
  const { reloadMeetings } = rootStore.meetingStore;
  const { isMobileMediaQuery } = rootStore.responsiveStore;
  const [activeYear, setActiveYear] = useState(
    meetingYears
      ? meetingYears[meetingYears.length - 1]
      : new Date().getFullYear()
  );
  const { theme, isNativeApp } = rootStore.commonStore;
  const {isBroadcastControllerOpen}= rootStore.broadcastStore;
  const { loadAlreadyDownloadedMeetings } = rootStore.offlineStore;
  const { setSourceId, setMeetingCardsToListOrNot, toListOrNot } = rootStore.meetingStore;
  const [t] = useTranslation(
    ["features", "translation"],
    translationHookOptions
  );
  const [indexArrayYear, setIndexArrayYear] = useState(
    meetingYears.indexOf(activeYear)
  );
  


  useEffect(() => {
    if (attendingMeeting) setSourceId(attendingMeeting?.id);
    else setSourceId(null);

    reloadMeetings().then().catch();
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let sidebarBorder = theme!.sidebarBorder;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty(
      "--sidebarBorder",
      `${sidebarBorder}`
    );
    const scrollableElement = document.querySelector(".contenitoreRiunioni");
    if (scrollableElement) disableBodyScroll(scrollableElement, {
      allowTouchMove: (el) => el,
    });
    return () => {
      const scrollableElement = document.querySelector(".contenitoreRiunioni");
      if (scrollableElement) enableBodyScroll(scrollableElement);
    };
  }, [
    reloadMeetings,
    isNativeApp,
    currentTenant,
    loadAlreadyDownloadedMeetings,
    attendingMeeting,
    theme,
    setSourceId,
    toListOrNot,
    t
  ]);

  const handleYearClick = (year: number) => {
    if(meetingYears.includes(year)){
      setActiveYear(year);
      setIndexArrayYear(meetingYears.indexOf(year));
    }
  };
  const handleToListOrNot = () => {
    setMeetingCardsToListOrNot(!toListOrNot);
  };

  return (
    <>
      <Row>
        <div
          className={classNames(
            "intestazioneAnni",
            `${theme?.yearSelectionBarColor}`
          )}
        >
          <div className={classNames(isMobileMediaQuery ? `SwitchToListDivMobile`: `SwitchToListDiv`)}></div>
          <div
            className={classNames(`${theme?.yearColor}`, isMobileMediaQuery ? `selettoreAnnoMobile`: `selettoreAnno`)}
            onClick={() => handleYearClick(meetingYears[indexArrayYear - 2])}
          >
            <b className="testoAnno">{meetingYears[indexArrayYear - 2]}</b>
          </div>
          <div
            className={classNames(isMobileMediaQuery ? `selettoreAnnoMobile`: `selettoreAnno`, `${theme?.yearColor}`)}
            onClick={() => handleYearClick(meetingYears[indexArrayYear - 1])}
          >
            <b className="testoAnno">{meetingYears[indexArrayYear - 1]}</b>
          </div>

          <div
            className={classNames(`${theme?.yearSelectedColor}`, isMobileMediaQuery ? `annoAttivoMobile `: `annoAttivo `)}
          >
            <b>{activeYear}</b>
          </div>

          <div
            className={classNames(isMobileMediaQuery ? `selettoreAnnoMobile`: `selettoreAnno`, `${theme?.yearColor}`)}
            onClick={() => handleYearClick(meetingYears[indexArrayYear + 1])}
          >
            <b className="testoAnno">{meetingYears[indexArrayYear + 1]}</b>
          </div>
          <div
            className={classNames(isMobileMediaQuery ? `selettoreAnnoMobile`: `selettoreAnno`, `${theme?.yearColor}`)}
            onClick={() => handleYearClick(meetingYears[indexArrayYear + 2])}
          >
            <b className="testoAnno">{meetingYears[indexArrayYear + 2]}</b>
          </div>
          <div className={classNames(isMobileMediaQuery ? `SwitchToListDivMobile`: ( isBroadcastControllerOpen ?`SwitchToListDivBroadcastOpen`: `SwitchToListDiv`))}
           onClick={ handleToListOrNot }>{(!toListOrNot)?<i className="fas fa-list ml-2" aria-hidden="true"></i>:<i className="fa fa-table" aria-hidden="true"></i>}</div>
        </div>
      </Row>
      <Container className={(!toListOrNot)? "" : "containerList"}>
        
        <Row className="contenitoreRiunioni">
          {orderedUserMeetings(activeYear).length < 1 ? (
            <div>{t("no_meetings", { ns: "translation" })}</div>
          ) : (
            orderedUserMeetings(activeYear).map((m) => (
              (!toListOrNot)?
              <Col xs={12} md={6} lg={4} xl={4} key={m.id}>
                <MeetingCard meeting={m} tenant={currentTenant!} toListOrNot={toListOrNot} />
              </Col>
              :
              <Col xs={12} md={6} lg={4} xl={4} key={m.id} className="listMaxWith">
                <MeetingCard meeting={m} tenant={currentTenant!} toListOrNot={toListOrNot}/>
              </Col>
            ))
          )}
        </Row>
        <MeetingAttendanceModal
          meeting={meetingAttendanceModal}
          redirect={(url) => history.push(url)}
        />
      </Container>
    </>
  );
};

export default observer(MeetingsPage);
